import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import { Product, ProductsService, Subscription } from '@/api/braendz';
import { BusyObject } from '@/models/Busy';

@Component
export default class ProductBase extends Vue {
    
    // Props
    public upgradeLevel: number | null | undefined = undefined;
    public product = new BusyObject<Product>();

    // Computed properties
    public get action(): 'test' | 'subscribe' | 'active' | 'upgrade' | 'downgrade' | null {
        if (this.upgradeLevel === undefined && !this.product.object) return null;
      
        const upgradeLevel = this.upgradeLevel ?? this.product.object?.upgradeLevel;
        if (!upgradeLevel) return 'test';

        const activeSubscription = this.$store.state.activeSubscription as BusyObject<Subscription>;
        const activeProduct = activeSubscription.object?.product;
        if (!activeProduct) return null;
        
        if (!activeProduct.upgradeLevel) return 'subscribe';
        if (activeProduct.upgradeLevel === upgradeLevel) return 'active';
        return activeProduct.upgradeLevel < upgradeLevel ? 'upgrade' : 'downgrade';
    }

    public get selectable(): boolean {
        if (this.action === null) return false;
        if (this.action === 'downgrade') return false;
        if (this.action === 'active') return false;

        const activeSubscription = this.$store.state.activeSubscription as BusyObject<Subscription>;
        const activeUpgradeLevel = activeSubscription.object?.product?.upgradeLevel;
        const upgradeLevel = this.upgradeLevel ?? this.product.object?.upgradeLevel;
        
        if(activeUpgradeLevel && !upgradeLevel) return false;
        return true;
    }

    // Methods
    public async loadProduct(productKey: string): Promise<void> {
        const product = await this.product.load(async () => {
            return await ProductsService.getProduct(productKey);
        });
        this.upgradeLevel = product?.upgradeLevel ?? null;
    }
}